let downloadUrl = "";
let $button;
let $container;
let $containerLoader;
let $containerNoResult;
let $productSKUInput;
let $typeSelect;
let $languageSelect;
let $productSKUForSubmit;


$(document).ready(function () {

    $button = $('#download');
    $button.click(handleDownload);

    downloadUrl = $button.attr('data-target-url');

    $container = $('#download-manuals-container');
    $containerLoader = $('#download-manuals-loader');
    $containerNoResult = $('#download-manuals-no-result');

    $productSKUInput = $('#sku-download');
    $typeSelect = $('#select-type');
    $languageSelect = $('#select-language');

    const shouldAutoSubmit = String($button.data('auto-submit')) === 'true';
    if (shouldAutoSubmit) {
        autoSubmit();
    }
});

function autoSubmit(){
    let sku = $productSKUInput.val();
    if(!sku){
        return;
    }

    showProgressLoader()

    let language = navigator.language.split('-')[0].toUpperCase();
    if(!language){
        language = "";
    }else{
        let languageExist = false;
        $("#select-language > option").each(function() {
            console.log(this.value);
            if(this.value === language.toLowerCase()){
                languageExist = true;
            }
        });

        if(languageExist){
            $languageSelect.val(language.toLowerCase());
            $languageSelect.trigger('change');
        }else {
            language = ""
        }
    }

    $.get(
        downloadUrl,
        {
            "productSKU": sku,
            "type": "",
            "language": language
        },
        showContent,
        'html'
    ).fail(showNoContent);
}

function handleDownload() {

    showProgressLoader();

    let sku = $productSKUInput.val();
    if (!sku) {
        return;
    }
    let selectedType = $typeSelect.val();
    let selectedLanguage = $languageSelect.val();

    $.get(
        downloadUrl,
        {
            "productSKU": sku,
            "type": selectedType,
            "language": selectedLanguage
        },
        showContent,
        'html'
    ).fail(showNoContent);
}

function showProgressLoader() {
    $containerNoResult.hide();
    $containerLoader.show();
}

function showContent(content) {
    $containerLoader.hide();
    $container.empty();
    $container.show();
    $container.append(content);
    $containerNoResult.hide();
    $container.find('a').attr('rel', 'nofollow');
}

function showNoContent() {
    console.log("NO CONTENT")
    $container.empty();
    $containerLoader.hide();
    $containerNoResult.show();
}